<div class="drop-shadow-card flex h-full w-full flex-col rounded-xl bg-white">
  <div
    class="border-b-theme-blue-gray flex h-fit w-full flex-row items-center gap-x-3 border-b p-1 pl-4">
    @for (documentClass of document()?.documentClasses ?? []; track documentClass) {
      <img
        [src]="`@shared/document-class/${documentClass}.svg`"
        loading="lazy"
        [alt]="documentClass"
        class="h-7" />
    }
    <span class="flex items-center gap-4 p-1 text-lg font-bold">
      <span class="py-3">{{ currentTableModel().label }}</span>
    </span>
  </div>
  <div
    class="h-full overflow-auto"
    ctExtractionOcrFormInput
    [activeField]="activeField()"
    [currentDocument]="document()">
    <!-- Since we render exactly one table during row classification it is always active -->
    <ct-extraction-table
      [capturingConfig]="capturingConfig()"
      [tableRows]="tableRows()"
      [isTableLayoutEditable]="false"
      [isClassificationView]="true"
      [(currentRowToClassify)]="currentRowToClassify"
      [isActive]="true"
      (currentTableCellChange)="currentTableCell.set($event)"
      (rowSelected)="onRowSelected($event)" />
  </div>
</div>
